document.addEventListener("DOMContentLoaded", function () {
  const POPUP_ID = "welcome-bogo-popup";
  const STORAGE_KEY = "welcome_bogo_popup_seen";
  const DELAY_MS = 3000; // Show after 3 seconds

  const popupOverlay = document.getElementById(POPUP_ID);
  if (!popupOverlay) return;

  const closeBtn = popupOverlay.querySelector(".welcome-bogo-popup__close");
  const ctaBtn = popupOverlay.querySelector(".welcome-bogo-popup__btn");
  const canvas = document.getElementById("welcome-bogo-confetti");

  // Check if user has already seen the popup
  const hasSeenPopup = localStorage.getItem(STORAGE_KEY);

  if (!hasSeenPopup) {
    setTimeout(showPopup, DELAY_MS);
  }

  function showPopup() {
    // Remove display: none to allow layout
    popupOverlay.style.display = "";

    // Force a reflow/repaint so the transition can trigger
    void popupOverlay.offsetWidth;

    popupOverlay.classList.add("is-visible");
    // Mark as seen immediately when shown
    localStorage.setItem(STORAGE_KEY, "true");

    // Start confetti
    if (canvas) {
      startConfetti(canvas);
    }
  }

  function closePopup() {
    popupOverlay.classList.remove("is-visible");
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      closePopup();
    });
  }

  // Close when clicking outside content (overlay)
  popupOverlay.addEventListener("click", function (e) {
    if (e.target === popupOverlay) {
      closePopup();
    }
  });

  // Also close when CTA is clicked
  if (ctaBtn) {
    ctaBtn.addEventListener("click", function () {
      closePopup();
    });
  }

  // Simple Confetti Implementation
  function startConfetti(canvas) {
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.parentElement.offsetWidth;
    canvas.height = canvas.parentElement.offsetHeight;

    const confettiCount = 200;
    const confetti = [];
    const colors = ["#F8D349", "#142c73", "#e74c3c", "#2ecc71", "#3498db"];

    for (let i = 0; i < confettiCount; i++) {
      confetti.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height - canvas.height,
        color: colors[Math.floor(Math.random() * colors.length)],
        size: Math.random() * 5 + 3,
        velocity: Math.random() * 3 + 3,
        angle: Math.random() * 360,
        spin: Math.random() < 0.5 ? -1 : 1,
      });
    }

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      let activeParticles = 0;

      confetti.forEach((p, i) => {
        if (p.y > canvas.height + p.size) return; // Skip if off screen

        activeParticles++;

        ctx.fillStyle = p.color;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.angle * Math.PI) / 180);
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
        ctx.restore();

        p.y += p.velocity;
        p.angle += p.spin;
        // Gravity effect
        p.velocity += 0.25;
      });

      if (
        activeParticles > 0 &&
        popupOverlay.classList.contains("is-visible")
      ) {
        requestAnimationFrame(draw);
      } else {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    }

    draw();

    // Resize handler
    window.addEventListener("resize", () => {
      canvas.width = canvas.parentElement.offsetWidth;
      canvas.height = canvas.parentElement.offsetHeight;
    });
  }
});
